import React, { useEffect, useRef, useState } from 'react';
import { CheckIcon, ClipboardCopyIcon } from '@heroicons/react/outline';
import Button from './Button';

/**
 * Clipboard action specified by the Parabot canvas. It owns the copy state,
 * accessible label, reset timing, and standard icon-button surface.
 */
export default function CopyButton({
  value,
  label = 'Copy',
  copiedLabel = 'Copied',
  onCopied,
  onError,
  ...props
}) {
  const [copied, setCopied] = useState(false);
  const resetTimer = useRef(null);

  useEffect(() => () => clearTimeout(resetTimer.current), []);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      onCopied?.(value);
      clearTimeout(resetTimer.current);
      resetTimer.current = setTimeout(() => setCopied(false), 1400);
    } catch (error) {
      onError?.(error);
    }
  };

  return (
    <Button
      {...props}
      aria-label={copied ? copiedLabel : label}
      iconOnly
      onClick={copy}
      size="sm"
      title={copied ? copiedLabel : label}
      variant="ghost"
    >
      {copied ? <CheckIcon className="h-3.5 w-3.5 text-bun-success" /> : <ClipboardCopyIcon className="h-3.5 w-3.5" />}
    </Button>
  );
}
